import { render, staticRenderFns } from "./ArtistCompanies.vue?vue&type=template&id=149abd18&scoped=true"
import script from "./ArtistCompanies.vue?vue&type=script&lang=ts"
export * from "./ArtistCompanies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149abd18",
  null
  
)

export default component.exports